import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loginOpen, setLoginOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem("zelo_user");
      if (raw) setUser(JSON.parse(raw));
    } catch (_) {}
  }, []);

  const persist = (u) => {
    setUser(u);
    if (u) localStorage.setItem("zelo_user", JSON.stringify(u));
    else localStorage.removeItem("zelo_user");
  };

  const logout = () => persist(null);

  return (
    <AuthContext.Provider value={{ user, setUser: persist, logout, loginOpen, setLoginOpen }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
